<template>
  <div class="trustees-container px-3 px-md-4 py-3">

    <!-- Page Header -->
    <div class="mb-3">
      <h2 class="fw-bold mb-1">Employees</h2>
    </div>

    <!-- Summary Cards -->
    <div class="row g-4 mb-4">
      <div class="col-12 col-md-4">
        <div class="glassy-table shadow-sm border-0 rounded-lg p-3 h-100">
          <p class="text-dark small mb-2">Total Employees</p>
          <h3 class="fw-bold mb-1">{{ sub_entity_stats.total }}</h3>
          <p class="text-success small mb-0">{{ sub_entity_stats.active }} active</p>
        </div>
      </div>

      <!--col-6 so this card shows on mobile too -->
      <div class="d-none col-6 col-md-6">
        <div class="glassy-table shadow-sm border-0 rounded-lg p-3 h-100">
          <p class="text-dark small mb-2">Next Meeting</p>
          <h3 class="fw-bold mb-1">15 Feb 2026</h3>
          <p class="text-dark small mb-0">Quarterly board meeting</p>
        </div>
      </div>
    </div>

    <!-- Employees Table Card -->
    <div class="glassy-table shadow-sm border-0 rounded-lg p-3 p-md-4">

      <div class="mb-4">
        <h4 class="fw-bold mb-1">Current employees</h4>
      </div>

      <!-- duplicate header that was outside v-else -->

      <!-- Empty state -->
      <div v-if="!is_loading_trustees && !trustees.length" class="text-center text-muted py-3">
        <i class="bi bi-person-x fs-4 mb-2 d-block"></i>
        No employees found
      </div>

      <template v-else>

        <!-- ── DESKTOP TABLE (md and up) ── -->
        <div class="d-none d-md-block">
          <div class="row text-dark text-xs fw-semibold border-bottom border-dark pb-2 mb-3">
            <div class="col-md-5">Employee Name</div>
            <div class="col-md-4">Sub Category Type</div>
            <div class="col-md-3">Date Added</div>
          </div>

          <div
            v-for="trustee in trustees"
            :key="trustee.id"
            class="row align-items-center py-3 border-bottom trustee-row g-2"
          >
            <div class="col-md-5 d-flex align-items-center text-xs">
              <div class="avatar-circle me-3">{{ trustee.initials }}</div>
              <div>
                <div class="fw-semibold">{{ trustee.name }}</div>
                <small class="text-success">Active</small>
              </div>
            </div>
            <div class="col-md-4">
              <span
                class="status-badge rounded-pill px-3 py-2 border"
                :class="role_badge_class(trustee.role)"
              >
                {{ trustee.role }}
              </span>
            </div>
            <div class="col-md-3 text-xs">
              <i class="bx bx-calendar me-2 text-muted"></i>
              {{ trustee.appointed }}
            </div>
          </div>
        </div>

        <!-- ── MOBILE CARDS (below md) ── -->
        <div class="d-flex d-md-none flex-column gap-3">
          <div
            v-for="trustee in trustees"
            :key="trustee.id"
            class="card border rounded-lg p-3 shadow-sm"
          >
            <div class="d-flex align-items-center gap-3 mb-3">
              <div class="avatar-circle flex-shrink-0">{{ trustee.initials }}</div>
              <div>
                <div class="fw-semibold text-xs">{{ trustee.name }}</div>
                <small class="text-success">Active</small>
              </div>
            </div>

            <div class="d-flex flex-column gap-2">
              <div class="d-flex justify-content-between align-items-center">
                <span class="text-muted text-xxs fw-semibold">Sub Category Type</span>
                <span
                  class="status-badge rounded-pill px-3 py-1 border text-xxs"
                  :class="role_badge_class(trustee.role)"
                >
                  {{ trustee.role }}
                </span>
              </div>
              <div class="d-flex justify-content-between align-items-center">
                <span class="text-muted text-xxs fw-semibold">Date Added</span>
                <span class="text-xxs">
                  <i class="bx bx-calendar me-1 text-muted"></i>
                  {{ trustee.appointed }}
                </span>
              </div>
            </div>
          </div>
        </div>

      </template>
    </div>

  </div>
</template>